import {API_ENDPOINT, AUTH_HEADERS} from "../../util/constants";
import {RSAA} from "redux-api-middleware";
import * as types from "../types/index";
import {handleUnauthorizedAccess} from "../../util/utility";

export function getBroacastEarnings(token, api_token, type, broadcast_id) {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/earnings-new?type=${type}&id=${broadcast_id}&api_token=${api_token}`,
            method: 'GET',
            headers: {
                ...AUTH_HEADERS,
                Authorization: `Bearer ${token}`
            },
            types: [types.GET_BROADCAST_EARNINGS_REQUEST, types.GET_BROADCAST_EARNINGS_RECEIVE, {
                type: types.GET_BROADCAST_EARNINGS_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

export const resetGetBroacastEarnings = () => ({
    type: types.RESET_GET_BROADCAST_EARNINGS,
    payload: null
});